import { Empty } from "antd";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { useScrollablePagination } from "../../hooks/useScrollablePagination";
import { onFilterMyFolders } from "../../utils/folders/filters";
import { CardComponent } from "../folders/CardComponent";
import { CoreLoading } from "../common/CoreLoading";
import { fetchMyFolders } from "../../redux/actions/folderActions";

export const Cards: React.FC = () => {
  const {
    results: folders,
    loading,
    filterChoice,
    sortingChoice,
    filterDates,
    filterUser,
  } = useAppSelector((state) => state.folder);
  const dispatch = useAppDispatch();
  const [isFiltered, setIsFiltered] = useState(false);

  const folderListRef = useRef<HTMLDivElement | null>(null);
  useScrollablePagination(folderListRef, fetchMyFolders);

  // Apply filters whenever filter criteria changes
  useEffect(() => {
    const applyFilter = async () => {
      // Skip filtering if waiting for user filter selection but none is provided
      if (filterChoice === "user" && !filterUser) return;

      setIsFiltered(true);
      await onFilterMyFolders(
        filterChoice,
        sortingChoice,
        filterDates,
        filterUser,
        null,
        dispatch,
      );
    };

    applyFilter();
  }, [filterChoice, sortingChoice, filterDates, filterUser, dispatch]);

  // Show loading state while filter is being applied
  if (loading) {
    return <CoreLoading size={2} />;
  }

  return (
    <div
      className="w-full flex flex-col justify-center items-center"
      ref={folderListRef}
    >
      {folders.length > 0 ? (
        folders.map((folder, index) => (
          <CardComponent key={folder.id || index} folder={folder} detailed />
        ))
      ) : (
        <div className="mx-auto mt-24">
          <Empty
            description={
              isFiltered
                ? "No se encontraron expedientes con los filtros aplicados"
                : "No tienes expedientes asignados"
            }
          />
        </div>
      )}
    </div>
  );
};
